import classnames from 'classnames'
import { FunctionalComponent } from 'preact'
import { ContentType } from './types'
import { getInsidedData } from '../utils/getInsidedData'

export interface TopicWidthProps {
  index: number
  topicsFullWidth: number
  totalTopics: number
}

export interface FeaturedCardContainerProps extends TopicWidthProps {
  className?: string
  featuredImage?: string
  contentType?: ContentType
}

const FeaturedCardContainer: FunctionalComponent<FeaturedCardContainerProps> = (props) => {
  const { className, contentType, featuredImage, children } = props

  return (
    <article
      className={classnames(className, 'featured-topic', {
        'featured-topic--featured-image': featuredImage,
        'featured-topic--idea': contentType === 'idea',
        'featured-topic--full-width': isFullWidth(props),
        'featured-topic--half-width': isHalfWidth(props)
      })}
    >
      {children}
    </article>
  )
}

export const isFullWidth = (props: TopicWidthProps): boolean => {
  const isMobile = getInsidedData()?.device === 'mobile'
  if (isMobile) {
    return false
  }
  const { index, totalTopics, topicsFullWidth } = props
  if (index < topicsFullWidth) {
    return true
  }
  if (totalTopics - topicsFullWidth === 1) {
    return true
  }
  return false
}

export const isHalfWidth = (props: TopicWidthProps): boolean => {
  if (isFullWidth(props)) {
    return false
  }
  const isMobile = getInsidedData()?.device === 'mobile'
  if (isMobile) {
    return false
  }
  const { index, totalTopics, topicsFullWidth } = props
  if (index < topicsFullWidth) {
    return true
  }
  if (totalTopics - topicsFullWidth === 2) {
    return true
  }
  if (totalTopics - topicsFullWidth === 4) {
    return true
  }
  return false
}

export default FeaturedCardContainer
